// extracted by mini-css-extract-plugin
export default {"container":"lOc6Od","title":"RiuR4S"};